export function parseLocaleNumber(raw: string): number | null {
  if (!raw || raw.trim() === '') return null;
  const normalized = raw
    .replace(/\s/g, '')
    .replace(',', '.');
  const num = Number(normalized);
  return isNaN(num) ? null : num;
}

export function formatFixed(num: number | null | undefined, decimals: number = 2): string {
  if (num === null || num === undefined || Number.isNaN(num)) return '';
  return num.toFixed(decimals);
}

export function formatCurrency(num: number | string | null | undefined): string {
  if (num === null || num === undefined) return '';
  const parsed = typeof num === 'string' ? parseFloat(num) : num;
  if (isNaN(parsed)) return '';
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(parsed);
}

export function isValidNumericInput(value: string): boolean {
  if (value === '' || value === '-') return true;
  const pattern = /^-?\d*[.,]?\d*$/;
  return pattern.test(value);
}

export function sanitizeNumericInput(value: string): string {
  let sanitized = value.replace(/[^\d.,-]/g, '');
  const parts = sanitized.split(/[.,]/);
  if (parts.length > 2) {
    sanitized = parts[0] + '.' + parts.slice(1).join('');
  }
  return sanitized;
}
